import { AxiosHelper } from "../axiosConfig";
import APIConstant from "../utils/apiConstant";

export const getLastUpdatedResolutions = (
  reference?: number,
  includeClosed?: boolean,
  pageNumber?: number,
  pageSize?: number
) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.FEEDBACK_GET_LASTUPDATED_RESOLUTIONS,
    {
      params: {
        reference: reference,
        includeClosed: includeClosed,
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    }
  );
};

export const getResolutionsByFeedbackId = (feedbackId?: number) => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.FEEDBACK_GET_RESOLUTIONSBYFEEDBACKID,
    {
      params: {
        feedbackId: feedbackId,
      },
    }
  );
};
export const getFeedbackResolutionsStatuses = () => {
  return AxiosHelper.axiosInstance().get(
    APIConstant.FEEDBACK_GET_RESOLUTION_STATUSES
  );
};

export const addFeedbackResolution = (feedbackResolution: any) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.FEEDBACK_CREATE_RESOLUTION,
    feedbackResolution,
    {}
  );
};

export const updateFeedbackResolution = (feedbackResolution: any) => {
  return AxiosHelper.axiosInstance().put(
    APIConstant.FEEDBACK_UPDATE_RESOLUTION,
    feedbackResolution,
    {}
  );
};
